export type GeoLevel = 'state' | 'district' | 'township';

export interface GeoItem {
  id: string;
  name: string;
  parentId?: string;
}

// --- Mock Data Layer ---
export const INITIAL_STATES: GeoItem[] = [
  { id: 's1', name: 'ကချင်ပြည်နယ်' },
  { id: 's2', name: 'ကယားပြည်နယ်' },
  { id: 's3', name: 'ကရင်ပြည်နယ်' },
  { id: 's4', name: 'ချင်းပြည်နယ်' },
  { id: 's5', name: 'စစ်ကိုင်းတိုင်း' },
  { id: 's6', name: 'တနင်္သာရီတိုင်း' },
  { id: 's7', name: 'ပဲခူးတိုင်း' },
  { id: 's8', name: 'မကွေးတိုင်း' },
  { id: 's9', name: 'မန္တလေးတိုင်း' },
  { id: 's10', name: 'မွန်ပြည်နယ်' },
  { id: 's11', name: 'ရခိုင်ပြည်နယ်' },
  { id: 's12', name: 'ရန်ကုန်တိုင်း' },
  { id: 's13', name: 'ရှမ်းပြည်နယ်' },
  { id: 's14', name: 'ဧရာဝတီတိုင်း' },
  { id: 's15', name: 'နေပြည်တော်' },
];

export const INITIAL_DISTRICTS: GeoItem[] = [
  // ကချင်
  { id: 'd1', name: 'မိုးညှင်းခရိုင်', parentId: 's1' },
  { id: 'd2', name: 'ဗန်းမော်ခရိုင်', parentId: 's1' },
  { id: 'd3', name: 'မြစ်ကြီးနားခရိုင်', parentId: 's1' },
  { id: 'd4', name: 'ပူတာအိုခရိုင်', parentId: 's1' },

  // ကယား
  { id: 'd5', name: 'လွိုင်ကော်ခရိုင်', parentId: 's2' },
  { id: 'd6', name: 'ဘော်လခဲခရိုင်', parentId: 's2' },

  // ကရင်
  { id: 'd7', name: 'ဘားအံခရိုင်', parentId: 's3' },
  { id: 'd8', name: 'မြဝတီခရိုင်', parentId: 's3' },
  { id: 'd9', name: 'ဖာပွန်ခရိုင်', parentId: 's3' },
  { id: 'd10', name: 'ကော့ကရိတ်ခရိုင်', parentId: 's3' },

  // ချင်း
  { id: 'd11', name: 'ဟားခါးခရိုင်', parentId: 's4' },
  { id: 'd12', name: 'ဖလမ်းခရိုင်', parentId: 's4' },
  { id: 'd13', name: 'မင်းတပ်ခရိုင်', parentId: 's4' },

  // စစ်ကိုင်း
  { id: 'd14', name: 'စစ်ကိုင်းခရိုင်', parentId: 's5' },
  { id: 'd15', name: 'မုံရွာခရိုင်', parentId: 's5' },
  { id: 'd16', name: 'ရွှေဘိုခရိုင်', parentId: 's5' },
  { id: 'd17', name: 'ကလေးခရိုင်', parentId: 's5' },
  { id: 'd18', name: 'တမူးခရိုင်', parentId: 's5' },
  { id: 'd19', name: 'ကသာခရိုင်', parentId: 's5' },

  // တနင်္သာရီ
  { id: 'd20', name: 'ထားဝယ်ခရိုင်', parentId: 's6' },
  { id: 'd21', name: 'မြိတ်ခရိုင်', parentId: 's6' },
  { id: 'd22', name: 'ကော့သောင်းခရိုင်', parentId: 's6' },

  // ပဲခူး
  { id: 'd23', name: 'ပဲခူးခရိုင်', parentId: 's7' },
  { id: 'd24', name: 'တောင်ငူခရိုင်', parentId: 's7' },
  { id: 'd25', name: 'ပြည်ခရိုင်', parentId: 's7' },
  { id: 'd26', name: 'သာယာဝတီခရိုင်', parentId: 's7' },

  // မကွေး
  { id: 'd27', name: 'မကွေးခရိုင်', parentId: 's8' },
  { id: 'd28', name: 'ပခုက္ကူခရိုင်', parentId: 's8' },
  { id: 'd29', name: 'မင်းဘူးခရိုင်', parentId: 's8' },
  { id: 'd30', name: 'သရက်ခရိုင်', parentId: 's8' },

  // မန္တလေး
  { id: 'd31', name: 'မန္တလေးခရိုင်', parentId: 's9' },
  { id: 'd32', name: 'ပြင်ဦးလွင်ခရိုင်', parentId: 's9' },
  { id: 'd33', name: 'ကျောက်ဆည်ခရိုင်', parentId: 's9' },
  { id: 'd34', name: 'မိတ္ထီလာခရိုင်', parentId: 's9' },
  { id: 'd35', name: 'ညောင်ဦးခရိုင်', parentId: 's9' },
  { id: 'd36', name: 'ရမည်းသင်းခရိုင်', parentId: 's9' },
  { id: 'd37', name: 'မြင်းခြံခရိုင်', parentId: 's9' },

  // မွန်
  { id: 'd38', name: 'မော်လမြိုင်ခရိုင်', parentId: 's10' },
  { id: 'd39', name: 'သထုံခရိုင်', parentId: 's10' },

  // ရခိုင်
  { id: 'd40', name: 'စစ်တွေခရိုင်', parentId: 's11' },
  { id: 'd41', name: 'ကျောက်ဖြူခရိုင်', parentId: 's11' },
  { id: 'd42', name: 'သံတွဲခရိုင်', parentId: 's11' },
  { id: 'd43', name: 'မောင်တောခရိုင်', parentId: 's11' },
  { id: 'd44', name: 'မြောက်ဦးခရိုင်', parentId: 's11' },

  // ရန်ကုန်
  { id: 'd45', name: 'ရန်ကုန်အရှေ့ခရိုင်', parentId: 's12' },
  { id: 'd46', name: 'ရန်ကုန်အနောက်ခရိုင်', parentId: 's12' },
  { id: 'd47', name: 'ရန်ကုန်တောင်ပိုင်းခရိုင်', parentId: 's12' },
  { id: 'd48', name: 'ရန်ကုန်မြောက်ပိုင်းခရိုင်', parentId: 's12' },

  // ရှမ်း
  { id: 'd49', name: 'တောင်ကြီးခရိုင်', parentId: 's13' },
  { id: 'd50', name: 'လားရှိုးခရိုင်', parentId: 's13' },
  { id: 'd51', name: 'ကျိုင်းတုံခရိုင်', parentId: 's13' },
  { id: 'd52', name: 'လွိုင်လင်ခရိုင်', parentId: 's13' },
  { id: 'd53', name: 'မူဆယ်ခရိုင်', parentId: 's13' },

  // ဧရာဝတီ
  { id: 'd54', name: 'ပုသိမ်ခရိုင်', parentId: 's14' },
  { id: 'd55', name: 'ဟင်္သာတခရိုင်', parentId: 's14' },
  { id: 'd56', name: 'မအူပင်ခရိုင်', parentId: 's14' },
  { id: 'd57', name: 'ဖျာပုံခရိုင်', parentId: 's14' },
  { id: 'd58', name: 'လပွတ္တာခရိုင်', parentId: 's14' },

  // နေပြည်တော်
  { id: 'd59', name: 'ဥတ္တရသီရိခရိုင်', parentId: 's15' },
  { id: 'd60', name: 'ဒက္ခိဏသီရိခရိုင်', parentId: 's15' },
  { id: 'd61', name: 'ပုဗ္ဗသီရိခရိုင်', parentId: 's15' },
  { id: 'd62', name: 'ဇေယျာသီရိခရိုင်', parentId: 's15' },
  { id: 'd63', name: 'ပျဉ်းမနားခရိုင်', parentId: 's15' },
  { id: 'd64', name: 'လယ်ဝေးခရိုင်', parentId: 's15' },
];

export const INITIAL_TOWNSHIPS: GeoItem[] = [
  // =========================
  // ကချင်ပြည်နယ်
  // =========================
  { id: 't1', name: 'မိုးညှင်း', parentId: 'd1' },
  { id: 't2', name: 'ဖားကန့်', parentId: 'd1' },
  { id: 't3', name: 'ဟိုပင်', parentId: 'd1' },
  { id: 't4', name: 'မိုးကောင်း', parentId: 'd1' },

  { id: 't5', name: 'ဗန်းမော်', parentId: 'd2' },
  { id: 't6', name: 'မိုးမောက်', parentId: 'd2' },
  { id: 't7', name: 'ရွှေကူ', parentId: 'd2' },
  { id: 't8', name: 'မန်စီ', parentId: 'd2' },

  { id: 't9', name: 'မြစ်ကြီးနား', parentId: 'd3' },
  { id: 't10', name: 'ဝိုင်းမော်', parentId: 'd3' },
  { id: 't11', name: 'အင်ဂျန်းယန်', parentId: 'd3' },
  { id: 't12', name: 'ချီဖွေ', parentId: 'd3' },

  { id: 't13', name: 'ပူတာအို', parentId: 'd4' },
  { id: 't14', name: 'နောင်မွန်း', parentId: 'd4' },
  { id: 't15', name: 'မချမ်းဘော', parentId: 'd4' },

  // =========================
  // ကယားပြည်နယ်
  // =========================
  { id: 't16', name: 'လွိုင်ကော်', parentId: 'd5' },
  { id: 't17', name: 'ဒီးမော့ဆို', parentId: 'd5' },
  { id: 't18', name: 'ဖရူဆို', parentId: 'd5' },

  { id: 't19', name: 'ဘော်လခဲ', parentId: 'd6' },
  { id: 't20', name: 'ဖားဆောင်း', parentId: 'd6' },
  { id: 't21', name: 'မယ်စဲ့', parentId: 'd6' },

  // =========================
  // ကရင်ပြည်နယ်
  // =========================
  { id: 't22', name: 'ဘားအံ', parentId: 'd7' },
  { id: 't23', name: 'လှိုင်းဘွဲ', parentId: 'd7' },
  { id: 't24', name: 'သံတောင်ကြီး', parentId: 'd7' },

  { id: 't25', name: 'မြဝတီ', parentId: 'd8' },
  { id: 't26', name: 'ကော့ကရိတ်', parentId: 'd10' },
  { id: 't27', name: 'ကြာအင်းဆိပ်ကြီး', parentId: 'd10' },
  { id: 't28', name: 'ဖာပွန်', parentId: 'd9' },

  // =========================
  // ချင်းပြည်နယ်
  // =========================
  { id: 't29', name: 'ဟားခါး', parentId: 'd11' },
  { id: 't30', name: 'ထန်တလန်', parentId: 'd11' },

  { id: 't31', name: 'ဖလမ်း', parentId: 'd12' },
  { id: 't32', name: 'တီးတိန်', parentId: 'd12' },
  { id: 't33', name: 'တွန်းဇံ', parentId: 'd12' },

  { id: 't34', name: 'မင်းတပ်', parentId: 'd13' },
  { id: 't35', name: 'ကန်ပက်လက်', parentId: 'd13' },
  { id: 't36', name: 'မတူပီ', parentId: 'd13' },
  { id: 't37', name: 'ပလက်ဝ', parentId: 'd13' },

  // =========================
  // စစ်ကိုင်းတိုင်း
  // =========================
  { id: 't38', name: 'စစ်ကိုင်း', parentId: 'd14' },
  { id: 't39', name: 'မြောင်', parentId: 'd14' },
  { id: 't40', name: 'မြင်းမူ', parentId: 'd14' },

  { id: 't41', name: 'မုံရွာ', parentId: 'd15' },
  { id: 't42', name: 'အရာတော်', parentId: 'd15' },
  { id: 't43', name: 'ချောင်းဦး', parentId: 'd15' },
  { id: 't44', name: 'ဘုတလင်', parentId: 'd15' },

  { id: 't45', name: 'ရွှေဘို', parentId: 'd16' },
  { id: 't46', name: 'ခင်ဦး', parentId: 'd16' },
  { id: 't47', name: 'ရေဦး', parentId: 'd16' },
  { id: 't48', name: 'ဝက်လက်', parentId: 'd16' },

  { id: 't49', name: 'ကလေး', parentId: 'd17' },
  { id: 't50', name: 'ကလေးဝ', parentId: 'd17' },

  { id: 't51', name: 'တမူး', parentId: 'd18' },

  { id: 't52', name: 'ကသာ', parentId: 'd19' },
  { id: 't53', name: 'ထီးချိုင့်', parentId: 'd19' },
  { id: 't54', name: 'အင်းတော်', parentId: 'd19' },

  // =========================
  // တနင်္သာရီတိုင်း
  // =========================
  { id: 't55', name: 'ထားဝယ်', parentId: 'd20' },
  { id: 't56', name: 'ရေဖြူ', parentId: 'd20' },
  { id: 't57', name: 'လောင်းလုံး', parentId: 'd20' },
  { id: 't58', name: 'သရက်ချောင်း', parentId: 'd20' },

  { id: 't59', name: 'မြိတ်', parentId: 'd21' },
  { id: 't60', name: 'ကျွန်းစု', parentId: 'd21' },
  { id: 't61', name: 'ပုလော', parentId: 'd21' },
  { id: 't62', name: 'တနင်္သာရီ', parentId: 'd21' },

  { id: 't63', name: 'ကော့သောင်း', parentId: 'd22' },
  { id: 't64', name: 'ဘုတ်ပြင်း', parentId: 'd22' },

  // =========================
  // ပဲခူးတိုင်း
  // =========================
  { id: 't65', name: 'ပဲခူး', parentId: 'd23' },
  { id: 't66', name: 'ကဝ', parentId: 'd23' },
  { id: 't67', name: 'သနပ်ပင်', parentId: 'd23' },
  { id: 't68', name: 'ဝေါ', parentId: 'd23' },

  { id: 't69', name: 'တောင်ငူ', parentId: 'd24' },
  { id: 't70', name: 'ရေတာရှည်', parentId: 'd24' },
  { id: 't71', name: 'ထန်းတပင်', parentId: 'd24' },
  { id: 't72', name: 'ဖြူး', parentId: 'd24' },

  { id: 't73', name: 'ပြည်', parentId: 'd25' },
  { id: 't74', name: 'ပေါင်းတည်', parentId: 'd25' },
  { id: 't75', name: 'ပေါက်ခေါင်း', parentId: 'd25' },
  { id: 't76', name: 'ရွှေတောင်', parentId: 'd25' },

  { id: 't77', name: 'သာယာဝတီ', parentId: 'd26' },
  { id: 't78', name: 'မင်းလှ', parentId: 'd26' },
  { id: 't79', name: 'လက်ပံတန်း', parentId: 'd26' },
  { id: 't80', name: 'အုတ်ဖို', parentId: 'd26' },

  // =========================
  // မကွေးတိုင်း
  // =========================
  { id: 't81', name: 'မကွေး', parentId: 'd27' },
  { id: 't82', name: 'တောင်တွင်းကြီး', parentId: 'd27' },
  { id: 't83', name: 'ချောက်', parentId: 'd27' },
  { id: 't84', name: 'ရေနံချောင်း', parentId: 'd27' },

  { id: 't85', name: 'ပခုက္ကူ', parentId: 'd28' },
  { id: 't86', name: 'ရေစကြို', parentId: 'd28' },
  { id: 't87', name: 'မြိုင်', parentId: 'd28' },
  { id: 't88', name: 'ဆိပ်ဖြူ', parentId: 'd28' },

  { id: 't89', name: 'မင်းဘူး', parentId: 'd29' },
  { id: 't90', name: 'စလင်း', parentId: 'd29' },
  { id: 't91', name: 'ငဖဲ', parentId: 'd29' },
  { id: 't92', name: 'စေတုတ္တရာ', parentId: 'd29' },

  { id: 't93', name: 'သရက်', parentId: 'd30' },
  { id: 't94', name: 'မင်းတုန်း', parentId: 'd30' },
  { id: 't95', name: 'ကံမ', parentId: 'd30' },

  // =========================
  // မန္တလေးတိုင်း
  // =========================
  { id: 't96', name: 'အောင်မြေသာစံ', parentId: 'd31' },
  { id: 't97', name: 'ချမ်းအေးသာစံ', parentId: 'd31' },
  { id: 't98', name: 'မဟာအောင်မြေ', parentId: 'd31' },
  { id: 't99', name: 'ချမ်းမြသာစည်', parentId: 'd31' },
  { id: 't100', name: 'ပြည်ကြီးတံခွန်', parentId: 'd31' },
  { id: 't101', name: 'အမရပူရ', parentId: 'd31' },
  { id: 't102', name: 'ပုသိမ်ကြီး', parentId: 'd31' },

  { id: 't103', name: 'ပြင်ဦးလွင်', parentId: 'd32' },
  { id: 't104', name: 'စဉ့်ကူး', parentId: 'd32' },
  { id: 't105', name: 'မတ္တရာ', parentId: 'd32' },

  { id: 't106', name: 'ကျောက်ဆည်', parentId: 'd33' },
  { id: 't107', name: 'စဉ့်ကိုင်', parentId: 'd33' },
  { id: 't108', name: 'မြစ်သား', parentId: 'd33' },

  { id: 't109', name: 'မိတ္ထီလာ', parentId: 'd34' },
  { id: 't110', name: 'ဝမ်းတွင်း', parentId: 'd34' },
  { id: 't111', name: 'သာစည်', parentId: 'd34' },

  { id: 't112', name: 'ညောင်ဦး', parentId: 'd35' },
  { id: 't113', name: 'ကျောက်ပန်းတောင်း', parentId: 'd35' },
  { id: 't114', name: 'ငါ့သရောက်', parentId: 'd35' },

  { id: 't115', name: 'ရမည်းသင်း', parentId: 'd36' },
  { id: 't116', name: 'ပျော်ဘွယ်', parentId: 'd36' },

  { id: 't117', name: 'မြင်းခြံ', parentId: 'd37' },
  { id: 't118', name: 'တောင်သာ', parentId: 'd37' },
  { id: 't119', name: 'နွားထိုးကြီး', parentId: 'd37' },
  { id: 't120', name: 'နတ်မောက်', parentId: 'd37' },

  // =========================
  // မွန်ပြည်နယ်
  // =========================
  { id: 't121', name: 'မော်လမြိုင်', parentId: 'd38' },
  { id: 't122', name: 'ကျိုက်မရော', parentId: 'd38' },
  { id: 't123', name: 'မုဒုံ', parentId: 'd38' },
  { id: 't124', name: 'ချောင်းဆုံ', parentId: 'd38' },

  { id: 't125', name: 'သထုံ', parentId: 'd39' },
  { id: 't126', name: 'ဘီးလင်း', parentId: 'd39' },
  { id: 't127', name: 'ကျိုက်ထို', parentId: 'd39' },
  { id: 't128', name: 'ပေါင်', parentId: 'd39' },

  // =========================
  // ရခိုင်ပြည်နယ်
  // =========================
  { id: 't129', name: 'စစ်တွေ', parentId: 'd40' },
  { id: 't130', name: 'ပေါက်တော', parentId: 'd40' },
  { id: 't131', name: 'ရသေ့တောင်', parentId: 'd40' },

  { id: 't132', name: 'ကျောက်ဖြူ', parentId: 'd41' },
  { id: 't133', name: 'မာန်အောင်', parentId: 'd41' },
  { id: 't134', name: 'ရမ်းဗြဲ', parentId: 'd41' },

  { id: 't135', name: 'သံတွဲ', parentId: 'd42' },
  { id: 't136', name: 'တောင်ကုတ်', parentId: 'd42' },
  { id: 't137', name: 'ဂွ', parentId: 'd42' },

  { id: 't138', name: 'မောင်တော', parentId: 'd43' },
  { id: 't139', name: 'ဘူးသီးတောင်', parentId: 'd43' },

  { id: 't140', name: 'မြောက်ဦး', parentId: 'd44' },
  { id: 't141', name: 'မင်းပြား', parentId: 'd44' },
  { id: 't142', name: 'ကျောက်တော်', parentId: 'd44' },

  // =========================
  // ရန်ကုန်တိုင်း
  // =========================
  { id: 't143', name: 'တာမွေ', parentId: 'd45' },
  { id: 't144', name: 'သင်္ဃန်းကျွန်း', parentId: 'd45' },
  { id: 't145', name: 'ဒဂုံမြို့သစ်(မြောက်ပိုင်း)', parentId: 'd45' },
  { id: 't146', name: 'ဒဂုံမြို့သစ်(တောင်ပိုင်း)', parentId: 'd45' },
  { id: 't147', name: 'ဒေါပုံ', parentId: 'd45' },
  { id: 't148', name: 'မင်္ဂလာတောင်ညွန့်', parentId: 'd45' },

  { id: 't149', name: 'လမ်းမတော်', parentId: 'd46' },
  { id: 't150', name: 'လသာ', parentId: 'd46' },
  { id: 't151', name: 'အလုံ', parentId: 'd46' },
  { id: 't152', name: 'ကြည့်မြင်တိုင်', parentId: 'd46' },
  { id: 't153', name: 'စမ်းချောင်း', parentId: 'd46' },
  { id: 't154', name: 'ကမာရွတ်', parentId: 'd46' },

  { id: 't155', name: 'သန်လျင်', parentId: 'd47' },
  { id: 't156', name: 'ကျောက်တံတား', parentId: 'd47' },
  { id: 't157', name: 'ဗိုလ်တထောင်', parentId: 'd47' },
  { id: 't158', name: 'ပုဇွန်တောင်', parentId: 'd47' },
  { id: 't159', name: 'ဒလ', parentId: 'd47' },
  { id: 't160', name: 'ဆိပ်ကြီးခနောင်တို', parentId: 'd47' },

  { id: 't161', name: 'အင်းစိန်', parentId: 'd48' },
  { id: 't162', name: 'မရမ်းကုန်း', parentId: 'd48' },
  { id: 't163', name: 'ရွှေပြည်သာ', parentId: 'd48' },
  { id: 't164', name: 'လှိုင်သာယာ', parentId: 'd48' },
  { id: 't165', name: 'မင်္ဂလာဒုံ', parentId: 'd48' },
  { id: 't166', name: 'ထန်းတပင်', parentId: 'd48' },

  // =========================
  // ရှမ်းပြည်နယ်
  // =========================
  { id: 't167', name: 'တောင်ကြီး', parentId: 'd49' },
  { id: 't168', name: 'ညောင်ရွှေ', parentId: 'd49' },
  { id: 't169', name: 'ဟိုပုံး', parentId: 'd49' },
  { id: 't170', name: 'ကလော', parentId: 'd49' },
  { id: 't171', name: 'ပင်းတယ', parentId: 'd49' },

  { id: 't172', name: 'လားရှိုး', parentId: 'd50' },
  { id: 't173', name: 'သိန္နီ', parentId: 'd50' },
  { id: 't174', name: 'တန့်ယန်း', parentId: 'd50' },

  { id: 't175', name: 'ကျိုင်းတုံ', parentId: 'd51' },
  { id: 't176', name: 'မိုင်းခတ်', parentId: 'd51' },
  { id: 't177', name: 'မိုင်းယန်း', parentId: 'd51' },

  { id: 't178', name: 'လွိုင်လင်', parentId: 'd52' },
  { id: 't179', name: 'ပင်လုံ', parentId: 'd52' },
  { id: 't180', name: 'နမ့်စန်', parentId: 'd52' },

  { id: 't181', name: 'မူဆယ်', parentId: 'd53' },
  { id: 't182', name: 'နမ့်ခမ်း', parentId: 'd53' },
  { id: 't183', name: 'ကွတ်ခိုင်', parentId: 'd53' },

  // =========================
  // ဧရာဝတီတိုင်း
  // =========================
  { id: 't184', name: 'ပုသိမ်', parentId: 'd54' },
  { id: 't185', name: 'ငပုတော', parentId: 'd54' },
  { id: 't186', name: 'ရေကြည်', parentId: 'd54' },
  { id: 't187', name: 'သပိတ်ကျင်း', parentId: 'd54' },

  { id: 't188', name: 'ဟင်္သာတ', parentId: 'd55' },
  { id: 't189', name: 'ဇလွန်', parentId: 'd55' },
  { id: 't190', name: 'လေးမျက်နှာ', parentId: 'd55' },

  { id: 't191', name: 'မအူပင်', parentId: 'd56' },
  { id: 't192', name: 'ညောင်တုန်း', parentId: 'd56' },
  { id: 't193', name: 'ပန်းတနော်', parentId: 'd56' },

  { id: 't194', name: 'ဖျာပုံ', parentId: 'd57' },
  { id: 't195', name: 'ဘိုကလေး', parentId: 'd57' },
  { id: 't196', name: 'ဒေးဒရဲ', parentId: 'd57' },

  { id: 't197', name: 'လပွတ္တာ', parentId: 'd58' },
  { id: 't198', name: 'မော်လမြိုင်ကျွန်း', parentId: 'd58' },

  // =========================
  // နေပြည်တော်
  // =========================
  { id: 't199', name: 'ဥတ္တရသီရိ', parentId: 'd59' },
  { id: 't200', name: 'ဇေယျာသီရိ', parentId: 'd62' },
  { id: 't201', name: 'ပုဗ္ဗသီရိ', parentId: 'd61' },
  { id: 't202', name: 'ဒက္ခိဏသီရိ', parentId: 'd60' },
  { id: 't203', name: 'ပျဉ်းမနား', parentId: 'd63' },
  { id: 't204', name: 'လယ်ဝေး', parentId: 'd64' },
  { id: 't205', name: 'တပ်ကုန်း', parentId: 'd64' },
];


export const INITIAL_POLICE_STATIONS: GeoItem[] =[
  { id: 'p1', name: 'တာမွေ ရဲစခန်း (၁)', parentId: 't143' },
  { id: 'p2', name: 'တာမွေ ရဲစခန်း (၂)', parentId: 't143' },
  { id: 'p3', name: 'တာမွေ ရဲစခန်း (၃)', parentId: 't143' },
]

export const LEVEL_LABELS: Record<GeoLevel, string> = {
  state: 'တိုင်းဒေသကြီး/ပြည်နယ်',
  district: 'ခရိုင်',
  township: 'မြို့နယ်',
};